/* eslint-disable */
import mixitup from 'mixitup';

export default {
    mixIt(){
        const containerEl = $('.shops-grid__items');
        const firstFilterlement = $('.shops-grid__filters > .filter:first-of-type').data('filter');

        const mixer = mixitup(containerEl, {
            load: {
                filter: firstFilterlement
            }
        });
    },
    
    init() {
        this.mixIt();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/page-shops.js